// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "select[data-v-23915442]{border:none;color:#0f4554!important;font-size:15px;font-weight:400}", ""]);
// Exports
module.exports = exports;
